import apiClient, { formatApiError } from "./client";

/**
 * Benachrichtigung (Notification) API Service
 * Maps to: BenachrichtigungController
 * Handles user-facing notifications (NOT AuditLog - that's for developers)
 */

export const getUnreadNotifications = async (oid) => {
  try {
    const response = await apiClient.get(`/api/benachrichtigung/ungelesen/${oid}`);
    return response.data;
  } catch (error) {
    console.error("getUnreadNotifications error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden der Benachrichtigungen") };
  }
};

export const getAllNotifications = async (oid, limit = 50) => {
  try {
    const response = await apiClient.get(`/api/benachrichtigung/alle/${oid}?limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error("getAllNotifications error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden der Benachrichtigungen") };
  }
};

export const markAsRead = async (benachrichtigungId, oid) => {
  try {
    const response = await apiClient.put(`/api/benachrichtigung/${benachrichtigungId}/gelesen?oid=${oid}`);
    return response.data;
  } catch (error) {
    console.error("markAsRead error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Markieren der Benachrichtigung") };
  }
};

export const markAllAsRead = async (oid) => {
  try {
    const response = await apiClient.put(`/api/benachrichtigung/alle-gelesen/${oid}`);
    return response.data;
  } catch (error) {
    console.error("markAllAsRead error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Markieren der Benachrichtigungen") };
  }
};
